/**
 * @module
 * @description JavaScript specific to the back to top button
 */

import _ from 'lodash'

import { on } from 'utils/events'

/* How far should the page scroll before showing the skip to top link? */
const SCROLL_TOP_OFFSET = 300

const el = {
	trigger: document.querySelector('[data-js="skip-link-top"]'),
}

const toggleSkipLink = () => {
	pageYOffset > SCROLL_TOP_OFFSET
		? el.trigger.classList.add('skip-link-top--is-active')
		: el.trigger.classList.remove('skip-link-top--is-active')
}

const bindEvents = () => {
	on(window, 'scroll', _.debounce(toggleSkipLink, 50))
}

/**
 * @function init
 * @description Kick off this modules functions
 */

const init = () => {
	if (!el.trigger) {
		return
	}

	bindEvents()
}

export default init
